import axios from 'axios';

import acknowledgeNotificationDTO from '../types/acknowledgeNotificationDTO';
import getNotificationDTO from '../types/getNotificationDTO';
import { FirebaseNotification } from '../types/Notification';
import { NotificationParams } from '../types/NotificationParams';
import { PageResponse } from '../types/PageResponse';

export const getNotification = (payload: getNotificationDTO) =>
  axios.post('notificationengine/api/notifications', payload);

export const getUnreadCount = () => axios.get('notificationengine/api/notifications/unread');

export const acknowledgeNotification = (payload: acknowledgeNotificationDTO) =>
  axios.put('notificationengine/api/notifications/acknowledge', payload);

export const acknowledgeNotificationMultiple = (payload: acknowledgeNotificationDTO[]) =>
  axios.put('notificationengine/api/notifications/acknowledge-multiple', payload);

export const markAllAsRead = () =>
  axios.post('notificationengine/api/notifications/firebase/mark-all-read');

export const markAsRead = (id: string) =>
  axios.post(`notificationengine/api/notifications/firebase/mark-read/${id}`);

export const getAllNotifications = (
  params: NotificationParams = { page: 0, size: 10, isRead: false }
) =>
  axios.get<PageResponse<FirebaseNotification>>(
    'notificationengine/api/notifications/firebase/all',
    {
      params,
    }
  );
export const getFirebaseUnreadCount = () =>
  axios.get<number>('notificationengine/api/notifications/firebase/unread/count');
